import React, { useState, useEffect } from "react";
import "../App/App.scss";
import "../../css/bootstrap.css";
import "../KnovoMainScreen/KnovoMainScreen.css";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import UserActions from "../../store/user/Actions";
import MenuHeader from "../CommonItems/MenuHeader/MenuHeader";
import MenuHeaderSenior from "../CommonItems/MenuHeader/MenuHeaderSenior";
import HomeScreen from "../HomeScreen/HomeScreen";
import KnovoClassesScreen from "../KnovoClassesScreen/KnovoClassesScreen";
import KnovoLessonScreen from "../KnovoLessonScreen/KnovoLessonScreen";
import { WarningPopup } from "root-components";
function KnovoMainScreen(props) {
  const history = useHistory();
  const { headerItemSelected, saveSpeechApi } = props; //redux from dispatch
  const [popupVisible, setPopupVisible] = useState(false);
  const isSenior = false;

  return (
    <section className="knovo-main-section">
      {isSenior ? (
        <MenuHeaderSenior
          onProfileClick={() => {
            setPopupVisible(true);
          }}
        />
      ) : (
        <MenuHeader
          onProfileClick={() => {
            setPopupVisible(true);
          }}
        />
      )}

      <div className="knovo-canvas-container">
        {headerItemSelected === "home" ? (
          <HomeScreen />
        ) : headerItemSelected === "classes" ? (
          <KnovoClassesScreen />
        ) : (
          <KnovoLessonScreen />
        )}
      </div>
      <WarningPopup
        popupVisible={popupVisible}
        onPopupCancel={() => {
          setPopupVisible(false);
        }}
        onPopupOk={() => {
          history.push("/login");
        }}
        popupHeadingLabel="Logout"
        popupMessageLabel="Are you sure. You want to logout ?"
      />
    </section>
  );
}

const mapStateToProps = (state) => ({
  headerItemSelected: state.user.headerItemSelected,
  speechApi: state.user.speechApi,
});

const mapDispatchToProps = (dispatch) => ({
  onHeaderItemSelected: (headerItemSelected) =>
    dispatch(UserActions.onHeaderItemSelected(headerItemSelected)),
  saveSpeechApi: (speechApi) => dispatch(UserActions.saveSpeechApi(speechApi)),
});
export default connect(mapStateToProps, mapDispatchToProps)(KnovoMainScreen);
